import axios from "axios";
import PROPERTIES from "../../Config/properties";
/**
 * [getPnlData Fetches data contianing shared P&L details]
 * @param  {Object} payload
 * @return {Promise}
 */
export const getPnlData = (payload) => axios.post(PROPERTIES.pnl_url, payload);
